import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const UnderlyingUniverseRouteLazy = lazyWithRetry(() => import('./UnderlyingUniverse'));
export function UnderlyingUniverseRoute() {
  return (
    <Suspense fallback={<LazyFallback />}>
      <UnderlyingUniverseRouteLazy />
    </Suspense>
  );
}
